import { IIcon } from './iconConstants'
const LinkedinIcon = ({ width, height, fill, stoke }: IIcon) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      enableBackground='new 0 0 28 28'
      width={width}
      height={height}
      viewBox='0 0 28 28'
      id='linkedin'
    >
      <path
        fill={fill}
        d='M5.086 9.711h3.002v9.031H5.086zM6.587 8.478h-.02a1.565 1.565 0 1 1 .04-3.12 1.565 1.565 0 1 1-.02 3.12zm12.325 10.264H15.91v-4.83c0-1.215-.434-2.043-1.52-2.043a1.643 1.643 0 0 0-1.54 1.098c-.078.236-.111.484-.1.732v5.043H9.75c0-.003.04-8.184 0-9.03h3.002v1.28a2.978 2.978 0 0 1 2.705-1.493c1.975 0 3.456 1.291 3.456 4.065v5.178z'
      />
      <path
        fill={stoke}
        d='M20.468 2H3.532a1.452 1.452 0 0 0-1.47 1.433v17.135c.011.8.669 1.442 1.47 1.432h16.936a1.451 1.451 0 0 0 1.47-1.432V3.433A1.451 1.451 0 0 0 20.467 2zM8.088 18.742H5.086V9.711h3.002v9.031zM6.833 8.48a1.57 1.57 0 0 1-.246-.002h-.02a1.565 1.565 0 1 1 .04-3.12 1.565 1.565 0 0 1 .226 3.122zm12.079 10.262H15.91v-4.83c0-1.215-.434-2.043-1.52-2.043a1.643 1.643 0 0 0-1.54 1.098 2.06 2.06 0 0 0-.1.732v5.043H9.75c0-.003.04-8.184 0-9.03h3.002v1.28a2.978 2.978 0 0 1 2.705-1.493c1.975 0 3.456 1.291 3.456 4.065v5.178z'
      />
    </svg>
  )
}
export default LinkedinIcon
